(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-equipment-selector"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.home-equipment-selector:not([data-selector-ready])');
    sections.forEach((section) => {
      section.dataset.selectorReady = 'true';
      const panel = section.querySelector('[data-selector-panel]');
      const back = section.querySelector('[data-selector-back]');
      const restart = section.querySelector('[data-selector-restart]');
      const progress = section.querySelector('[data-progress-bar]');
      const config = JSON.parse(section.querySelector('[data-selector-config]').textContent);
      const history = [];
      const answers = {};
      let started = false;

      const track = (event, detail = {}) => {
        const payload = { event, selector_location: 'homepage', selector_name: 'equipment_selector', ...detail };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
        section.dataset.selectorLastEvent = event;
        document.dispatchEvent(new CustomEvent('tmc:selector-event', { detail: payload }));
      };

      const icons = {
        laser: '<svg viewBox="0 0 48 48" aria-hidden="true"><circle cx="24" cy="24" r="7"/><path d="M24 5v9M24 34v9M5 24h9M34 24h9M10.6 10.6l6.4 6.4M31 31l6.4 6.4M37.4 10.6L31 17M17 31l-6.4 6.4"/></svg>',
        cnc: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M8 40h32M11 40V9h26v31M11 14h26M18 14v10h12V14M24 24v10M21 34h6M15 30H9M39 30h-6"/></svg>',
        welder: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M9 36l13-13 7 7-13 13H9v-7zM24 21l4-4 7 7-4 4M35 12v-5M39 14l4-4M37 19h6"/></svg>',
        help: '<svg viewBox="0 0 48 48" aria-hidden="true"><circle cx="24" cy="24" r="18"/><path d="M18.5 18a6 6 0 0111 3.2c0 4.3-5.5 4.8-5.5 9.3M24 37h.01"/></svg>',
        metal: '<svg viewBox="0 0 48 48" aria-hidden="true"><rect x="8" y="12" width="32" height="24" rx="3"/><path d="M17 20h14M17 28h9M35 7v6M32 10h6"/></svg>',
        organic: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M39 9C21 10 11 19 10 37c18-1 27-11 29-28zM10 37c8-9 14-14 23-20"/></svg>',
        delicate: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M24 6s11 13 11 23a11 11 0 01-22 0C13 19 24 6 24 6zM19 31c1 3 3 4 6 4"/></svg>',
        mixed: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M24 7L6 17l18 10 18-10L24 7zM8 25l16 9 16-9M8 33l16 9 16-9"/></svg>',
        mark: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M9 9h11v11H9zM28 9h11v11H28zM9 28h11v11H9zM29 29h4v4h-4zM35 28h4v11H28v-4"/></svg>',
        pulse: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M5 25h9l4-11 7 22 5-15 4 4h9"/></svg>',
        desktop: '<svg viewBox="0 0 48 48" aria-hidden="true"><rect x="7" y="10" width="34" height="25" rx="3"/><path d="M18 41h12M24 35v6M13 16h22v13H13z"/></svg>',
        industrial: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M7 39V19l9 6V15l9 6V9h16v30H7zM31 16h4M31 23h4M31 30h4M13 32h5"/></svg>',
        creative: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M9 39c8-15 16-23 30-30M13 29l6 6M23 19l6 6M33 9l6 6M8 40h32"/></svg>',
        precision: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M8 12h25v8H8zM13 20v16M28 20v10M8 36h12M8 31h5M33 8v16M38 8v16"/></svg>',
        clean: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M9 36l13-13 7 7-13 13H9v-7zM24 21l4-4 7 7-4 4M36 9v8M32 13h8"/></svg>'
        ,usecase: '<svg viewBox="0 0 48 48" aria-hidden="true"><circle cx="24" cy="24" r="16"/><circle cx="24" cy="24" r="8"/><path d="M24 4v7M24 37v7M4 24h7M37 24h7"/></svg>'
      };

      const choices = {
        start: {
          question: config.heading,
          progress: 25,
          options: [
            ['laser', 'laser', 'Laser Engraving & Cutting', 'Engrave metal, cut wood or acrylic, mark glass and make products.', 'Most popular'],
            ['cnc', 'cnc', 'CNC Routing & Carving', 'Carve wood, plastics or aluminum for signs, parts and furniture.'],
            ['welder', 'welder', 'Handheld Laser Welding', 'Weld, clean or cut metal faster with less finishing.'],
            ['unsure', 'help', 'I’m Not Sure', 'Tell us about the application and get expert guidance.']
          ]
        },
        laser: {
          question: 'What material will you work with most?', progress: 50,
          options: [
            ['metal', 'metal', 'Metal', 'Steel, aluminum, brass, jewelry, tools or coated metals.'],
            ['organic', 'organic', 'Wood & Acrylic', 'Signs, tumblers, gifts, leather or sheet goods.'],
            ['delicate', 'delicate', 'Glass & Plastics', 'Fine, low-heat marking on delicate or transparent materials.'],
            ['mixed', 'mixed', 'A Mix of Materials', 'You need flexibility across several material types.']
          ]
        },
        metal: {
          question: 'What do you need to do on metal?', progress: 75,
          options: [
            ['metal_standard', 'mark', 'Permanent Marking', 'Serials, logos, barcodes and deep engraving.'],
            ['metal_mopa', 'pulse', 'Color & Fine Control', 'Color marking, plastics and a wider pulse-width range.'],
            ['metal_use_cases', 'usecase', 'I Already Know My Use Case', 'Shop popular metal applications, including firearms and tumblers.']
          ]
        },
        organic: {
          question: 'What size and production level fits you?', progress: 75,
          options: [
            ['co2_standard', 'desktop', 'Desktop to Mid-Size', 'General product work, signs, gifts and small-batch production.'],
            ['co2_industrial', 'industrial', 'Large or Production-Scale', 'Larger beds, higher throughput and industrial workflows.'],
            ['wood_use_cases', 'usecase', 'I Already Know My Use Case', 'Shop popular wood, acrylic, stone and leather applications.']
          ]
        },
        cnc: {
          question: 'What best describes your CNC work?', progress: 75,
          options: [
            ['cnc_result', 'creative', 'Signs & Creative Work', 'Wood, plastics, reliefs, furniture parts and maker projects.'],
            ['cnc_result', 'precision', 'Precision Parts', 'Detailed prototypes, aluminum and repeatable production work.'],
            ['cnc_use_cases', 'usecase', 'I Already Know My Use Case', 'Shop popular CNC applications by material and project.']
          ]
        },
        metal_use_cases: {
          question: 'Which metal use case are you shopping for?', progress: 100,
          options: [
            ['metal_firearms', 'usecase', 'Firearms', 'Laser engravers for firearm marking and customization.', '', config.metalFirearmsUrl],
            ['metal_tumblers', 'usecase', 'Tumblers', 'Machines for logos, names and full-wrap tumbler work.', '', config.metalTumblersUrl],
            ['metal_brass', 'usecase', 'Brass', 'Engraving and marking solutions for brass parts.', '', config.metalBrassUrl],
            ['metal_other', 'help', 'Another Metal Use Case', 'Browse the full metal laser collection.', '', config.metalOtherUrl]
          ]
        },
        wood_use_cases: {
          question: 'Which material or use case are you shopping for?', progress: 100,
          options: [
            ['wood', 'organic', 'Wood', 'Laser cutters and engravers for wood products and projects.', '', config.woodUrl],
            ['acrylic', 'creative', 'Acrylic', 'Cut signs, displays, awards and custom acrylic products.', '', config.acrylicUrl],
            ['stone', 'mark', 'Stone', 'Engrave slate, granite, marble and similar materials.', '', config.stoneUrl],
            ['wood_other', 'help', 'Another Use Case', 'Browse all laser engravers and cutters.', '', config.woodOtherUrl]
          ]
        },
        cnc_use_cases: {
          question: 'Which CNC use case are you shopping for?', progress: 100,
          options: [
            ['cnc_foam', 'creative', 'Foam', 'CNC machines for foam molds, props and prototypes.', '', config.cncFoamUrl],
            ['cnc_aluminum', 'precision', 'Aluminum', 'CNC machines suited to accurate aluminum work.', '', config.cncAluminumUrl],
            ['cnc_steel', 'metal', 'Steel', 'Machines built for demanding steel applications.', '', config.cncSteelUrl],
            ['cnc_other', 'help', 'Another CNC Use Case', 'Browse the full CNC machine collection.', '', config.cncOtherUrl]
          ]
        },
        welder: {
          question: 'What is your primary metal workflow?', progress: 75,
          options: [
            ['welder_result', 'welder', 'Welding', 'Fast joins with low heat input and less post-processing.'],
            ['welder_result', 'clean', 'Cleaning or Cutting Too', 'A multi-function system for welding plus surface preparation.']
          ]
        }
      };

      const results = {
        metal_standard: ['Fiber Laser Engravers', 'The strongest starting point for durable metal marking, serials, logos and deep engraving.', config.fiberUrl, 'Compare fiber laser engravers'],
        metal_mopa: ['MOPA Fiber Laser Engravers', 'Best when you want added pulse control, color marking capability and more flexibility on plastics.', config.mopaUrl, 'Compare MOPA fiber lasers'],
        co2_standard: ['CO₂ Laser Engravers & Cutters', 'A versatile fit for wood, acrylic, leather, coated tumblers and general product work.', config.co2Url, 'Compare CO₂ laser machines'],
        co2_industrial: ['Industrial CO₂ Lasers', 'Built for larger work areas, higher duty cycles and production-focused cutting or engraving.', config.industrialCo2Url, 'Compare industrial CO₂ lasers'],
        delicate: ['UV Laser Marking Machines', 'Low-heat UV marking is the best place to start for glass, many plastics and delicate materials.', config.uvUrl, 'Compare UV laser markers'],
        mixed: ['Laser Engravers & Cutters', 'Start with the full laser range, then use the collection selectors to narrow by material, process and budget.', config.laserUrl, 'Explore laser engravers'],
        cnc_result: ['CNC Routers & Carving Machines', 'Compare desktop and production-capable CNC options for wood, plastics, aluminum and detailed parts.', config.cncUrl, 'Explore CNC machines'],
        welder_result: ['Handheld Laser Welders', 'Compare the Theo, Xlaserlab and Herolaser options selected for different workloads and functions.', config.welderUrl, 'Use the welder selector'],
        unsure: ['Talk With an Equipment Specialist', 'Tell us what you make, the materials involved and your budget. We’ll help narrow the right process and machine.', config.consultUrl, 'Get expert guidance']
      };

      const renderStep = (key, recordHistory = true) => {
        const step = choices[key];
        if (recordHistory && panel.dataset.step && panel.dataset.step !== key) history.push(panel.dataset.step);
        panel.dataset.step = key;
        progress.style.width = `${step.progress}%`;
        panel.innerHTML = `<h3>${step.question}</h3><div class="home-equipment-selector__grid">${step.options.map((option) => option[5] ? `<a class="home-equipment-selector__choice" href="${option[5]}" data-use-case="${option[0]}"><span class="home-equipment-selector__choice-icon">${icons[option[1]]}</span><span class="home-equipment-selector__choice-copy"><strong>${option[2]}</strong><small>${option[3]}</small></span></a>` : `<button type="button" class="home-equipment-selector__choice" data-value="${option[0]}"><span class="home-equipment-selector__choice-icon">${icons[option[1]]}</span><span class="home-equipment-selector__choice-copy">${option[4] ? `<span class="home-equipment-selector__badge">${option[4]}</span>` : ''}<strong>${option[2]}</strong><small>${option[3]}</small></span></button>`).join('')}</div>`;
        back.hidden = key === 'start';
        restart.hidden = true;
        track('selector_step_view', { selector_step: key });
      };

      const renderResult = (key) => {
        const result = results[key];
        if (panel.dataset.step && panel.dataset.step !== 'result') history.push(panel.dataset.step);
        panel.dataset.step = 'result';
        progress.style.width = '100%';
        panel.innerHTML = `<div class="home-equipment-selector__result"><p class="home-equipment-selector__result-label">Your best starting point</p><h3>${result[0]}</h3><p>${result[1]}</p><a href="${result[2]}" data-recommendation="${key}">${result[3]} →</a></div>`;
        back.hidden = false;
        restart.hidden = false;
        try { sessionStorage.setItem('tmc_selector_source', 'homepage'); sessionStorage.setItem('tmc_selector_result', key); } catch (error) {}
        track('selector_complete', { selector_result: key, selector_vertical: answers.vertical || key });
      };

      panel.addEventListener('click', (event) => {
        const choice = event.target.closest('[data-value]');
        const useCase = event.target.closest('[data-use-case]');
        const recommendation = event.target.closest('[data-recommendation]');
        if (useCase) {
          event.preventDefault();
          track('selector_use_case_click', { selector_use_case: useCase.dataset.useCase, selector_vertical: answers.vertical, link_url: useCase.href });
          window.location.assign(useCase.href);
          return;
        }
        if (recommendation) {
          track('selector_recommendation_click', { selector_result: recommendation.dataset.recommendation, link_url: recommendation.href });
          return;
        }
        if (!choice) return;
        const value = choice.dataset.value;
        const current = panel.dataset.step;
        if (!started) { started = true; track('selector_start'); }
        if (current === 'start') {
          answers.vertical = value;
          track('selector_vertical_select', { selector_vertical: value });
        }
        track('selector_answer', { selector_step: current, selector_answer: value, selector_vertical: answers.vertical || value });
        if (choices[value]) renderStep(value);
        else renderResult(value);
      });

      back.addEventListener('click', () => {
        const previous = history.pop() || 'start';
        renderStep(previous, false);
      });
      restart.addEventListener('click', () => {
        history.length = 0;
        Object.keys(answers).forEach((key) => delete answers[key]);
        renderStep('start', false);
        track('selector_restart');
      });
      section.querySelector('[data-selector-human]').addEventListener('click', (event) => {
        track('selector_human_help_click', { link_url: event.currentTarget.href });
      });

      renderStep('start', false);
      track('selector_view');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
